import Duck from 'extensible-duck';

export default new Duck({
  namespace: 'GEWEB',
  store: 'newHistory',
  initialState: {
    historyBookingFilter: {},
    historyBookingSelection: [],
    historyDeliveriesV2: { loading: false, error: false },

    ongoingBookingFilter: {},
    ongoingBookingSelection: [],
    ongoingDeliveriesV2: { loading: false, error: false },
    ongoingIntervalId: {},

    waybill: {},

    bookAgain: {
      loading: false,
      error: false,
      lastUpdated: 0,
      deliveriesV2: undefined,
    },
  },
  types: [
    'FETCH_LAST_COMPLETED_ORDER',
    'FETCH_HISTORY_BOOKINGS',
    'FETCH_HISTORY_BOOKINGS_ERROR',
    'SET_HISTORY_BOOKINGS',
    'UPDATE_HISTORY_BOOKING_FILTER',
    'UPDATE_HISTORY_BOOKINGS_SELECTION',

    'FETCH_ONGOING_BOOKINGS',
    'FETCH_ONGOING_BOOKINGS_ERROR',
    'SET_ONGOING_BOOKINGS',
    'UPDATE_ONGOING_BOOKING_FILTER',
    'UPDATE_ONGOING_BOOKINGS_SELECTION',
    'SET_ONGOING_INTERVAL_ID',

    'UPDATE_WAYBILL',

    'FETCH_BOOK_AGAIN',
    'SET_BOOK_AGAIN',
    'FETCH_BOOK_AGAIN_ERROR',

    'LIST_CANCELLATION_REASONS',
    'CANCEL_DELIVERIES',
    'SUBMIT_CANCEL_REASON_FOR_DELIVERIES',
  ],
  creators: duck => ({
    fetchLastCompletedOrder: () => ({
      type: duck.types.FETCH_LAST_COMPLETED_ORDER,
    }),
    fetchHistoryBookings: () => ({
      type: duck.types.FETCH_HISTORY_BOOKINGS,
    }),
    fetchHistoryBookingsError: () => ({
      type: duck.types.FETCH_HISTORY_BOOKINGS_ERROR,
    }),
    updateHistoryBookingFilter: updatedFilter => ({
      type: duck.types.UPDATE_HISTORY_BOOKING_FILTER,
      updatedFilter,
    }),
    setHistoryBookings: ({ deliveriesV2 }) => ({
      type: duck.types.SET_HISTORY_BOOKINGS,
      deliveriesV2,
    }),
    fetchOngoingBookings: () => ({
      type: duck.types.FETCH_ONGOING_BOOKINGS,
    }),
    fetchOngoingBookingsError: () => ({
      type: duck.types.FETCH_ONGOING_BOOKINGS_ERROR,
    }),
    setOngoingBookings: ({ deliveriesV2 }) => ({
      type: duck.types.SET_ONGOING_BOOKINGS,
      deliveriesV2,
    }),
    updateOngoingBookingFilter: updatedFilter => ({
      type: duck.types.UPDATE_ONGOING_BOOKING_FILTER,
      updatedFilter,
    }),
    updateOngoingBookingSelection: updatedSelection => ({
      type: duck.types.UPDATE_ONGOING_BOOKINGS_SELECTION,
      updatedSelection,
    }),
    updateHistoryBookingSelection: updatedSelection => ({
      type: duck.types.UPDATE_HISTORY_BOOKINGS_SELECTION,
      updatedSelection,
    }),
    setOngoingIntervalId: (page, id) => ({
      type: duck.types.SET_ONGOING_INTERVAL_ID,
      page,
      id,
    }),
    updateWaybill: (windowName, orders) => ({
      type: duck.types.UPDATE_WAYBILL,
      windowName,
      orders,
    }),
    fetchBookAgain: () => ({ type: duck.types.FETCH_BOOK_AGAIN }),
    setBookAgain: ({ deliveriesV2 }) => ({
      type: duck.types.SET_BOOK_AGAIN,
      deliveriesV2,
    }),
    fetchBookAgainError: () => ({
      type: duck.types.FETCH_BOOK_AGAIN_ERROR,
    }),
    cancelDeliveries: deliveries => ({
      type: duck.types.CANCEL_DELIVERIES,
      deliveries,
    }),
    submitCancelReasonForDeliveries: (deliveries, cancelRequest) => ({
      type: duck.types.SUBMIT_CANCEL_REASON_FOR_DELIVERIES,
      deliveries,
      cancelRequest,
    }),
    listCancellationReasons: deliveries => ({
      type: duck.types.LIST_CANCELLATION_REASONS,
      deliveries,
    }),
  }),
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.UPDATE_HISTORY_BOOKING_FILTER: {
        const { updatedFilter } = action;
        return {
          ...state,
          historyBookingFilter: {
            ...state.historyBookingFilter,
            ...updatedFilter,
          },
        };
      }
      case duck.types.FETCH_HISTORY_BOOKINGS: {
        return {
          ...state,
          historyDeliveriesV2: {
            ...state.historyDeliveriesV2,
            loading: true,
          },
        };
      }
      case duck.types.FETCH_HISTORY_BOOKINGS_ERROR: {
        return {
          ...state,
          historyDeliveriesV2: {
            loading: false,
            error: true,
          },
        };
      }
      case duck.types.SET_HISTORY_BOOKINGS: {
        const { deliveriesV2 } = action;
        return {
          ...state,
          historyDeliveriesV2: {
            ...deliveriesV2,
            loading: false,
          },
        };
      }
      case duck.types.FETCH_ONGOING_BOOKINGS: {
        return {
          ...state,
          ongoingDeliveriesV2: {
            ...state.ongoingDeliveriesV2,
            loading: true,
          },
        };
      }
      case duck.types.FETCH_ONGOING_BOOKINGS_ERROR: {
        return {
          ...state,
          ongoingDeliveriesV2: {
            loading: false,
            error: true,
          },
        };
      }
      case duck.types.SET_ONGOING_BOOKINGS: {
        const { deliveriesV2 } = action;
        return {
          ...state,
          ongoingDeliveriesV2: {
            ...deliveriesV2,
            loading: false,
            lastUpdated: +new Date(),
          },
        };
      }
      case duck.types.UPDATE_ONGOING_BOOKING_FILTER: {
        const { updatedFilter } = action;
        return {
          ...state,
          ongoingBookingFilter: {
            ...state.ongoingBookingFilter,
            ...updatedFilter,
          },
        };
      }
      case duck.types.UPDATE_ONGOING_BOOKINGS_SELECTION: {
        const { updatedSelection } = action;
        return { ...state, ongoingBookingSelection: updatedSelection };
      }
      case duck.types.UPDATE_HISTORY_BOOKINGS_SELECTION: {
        const { updatedSelection } = action;
        return { ...state, historyBookingSelection: updatedSelection };
      }
      case duck.types.UPDATE_WAYBILL: {
        const { windowName, orders } = action;
        return {
          ...state,
          waybill: { ...state.waybill, [windowName]: orders },
        };
      }
      case duck.types.FETCH_BOOK_AGAIN: {
        return {
          ...state,
          bookAgain: {
            ...state.bookAgain,
            loading: true,
          },
        };
      }
      case duck.types.SET_ONGOING_INTERVAL_ID: {
        const { page, id } = action;
        return {
          ...state,
          ongoingIntervalId: { ...state.ongoingIntervalId, [page]: id },
        };
      }
      case duck.types.FETCH_BOOK_AGAIN_ERROR: {
        return {
          ...state,
          bookAgain: {
            ...state.bookAgain,
            loading: false,
            error: true,
          },
        };
      }
      case duck.types.SET_BOOK_AGAIN: {
        const { deliveriesV2 } = action;
        return {
          ...state,
          bookAgain: {
            ...state.bookAgain,
            loading: false,
            deliveriesV2,
            lastUpdated: +new Date(),
          },
        };
      }
      default: {
        return state;
      }
    }
  },
});
